import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { Home } from './Home';
import { GridCaster } from './GridCaster/GridCaster';
import { EarlyAccess } from './EarlyAccess/EarlyAccess';
import MainMenu from './MainMenu.js';
import { About } from './About/About.js'
import { Press } from './Press/Press.js'

import './App.css';

import ScrollToTopOnMount from './Utils/ScrollToTopOnMount';

class App extends Component 
{
	render() 
	{	
		return (
			<Router>
				<ScrollToTopOnMount>
				<div>
					<MainMenu />
					<Route exact path="/" render={() => (
						<Home logo={this.props.logo} />
					)} />
					<Route path="/gridcaster" render={() => (
						<GridCaster />
					)} />
					<Route path="/early" render={() => (
						<EarlyAccess />
					)} />
					<Route path="/about" render={() => (
						<About logo={this.props.logo} />
					)} />
					<Route path="/press" render={() => (
						<Press logo={this.props.logo} />
					)} />
				</div>
				</ScrollToTopOnMount>
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js